export default __webpack_public_path__ + "static/add-example-1230f9def6acd819aa9fe717f768b2ff.gif";